<template>
  <div class="main end">
    <div class="header center">
      <img class="hero" src="@/assets/img/dead-end.svg" alt="Dead Icon" />
      <div class="title">
        <h1>GAME OVER</h1>
        <span>All people died till {{ $store.state.finalDate }}</span>
      </div>
    </div>
    <div class="content">
      <div class="text">
        <div class="sub">
          <div class="icon center">
            <img src="@/assets/img/pop-healed.svg" alt="Healed" />
          </div>
          <p>{{ fHealed }} Survived</p>
        </div>
        <span
          >You was one of survived peope. Survived people created time machine
          and sent you back with <span class="bold">{{ fMoney }}</span> money.
          <br /><br />

          You are the only one who can save the world by playing this funny
          simulation game.</span
        >
      </div>
    </div>
    <transition name="fade">
      <a class="button" @click="restart" v-if="showButton">Continue</a>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showButton: false,
    };
  },
  computed: {
    fMoney: function() {
      return this.$store.state.money
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    fHealed: function() {
      return this.$store.state.healed
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },

  mounted: function() {
    if (this.$store.state.gameOver) {
      setTimeout(() => {
        this.showButton = true;
      }, 2000);
    } else {
      this.$router.push("/");
    }
  },
  methods: {
    restart: function() {
      this.track("level_start", "viruzz 02 lost");
      this.$store.commit("resetGame");
      setTimeout(() => {
        this.$router.push("/game");
      }, 10);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/index.scss";
.end {
  display: flex;
  flex-direction: column;

  .header {
    background: #000;
    padding-bottom: 60px;

    .title {
      text-align: center;
      h1 {
        color: $red;
        margin-bottom: 8px;
        font-family: "Roboto Mono", monospace;
      }
      span {
        color: $orange;
        font-weight: bold;
      }
    }
  }

  .hero {
    margin-top: 32px;
    min-width: 175px;
  }
  .content {
    margin: 0 16px;

    .text {
      background: #fff;
      padding: 16px;
      border-radius: 12px;
      font-family: "Roboto Mono", monospace;
      margin: -24px 16px 16px 16px;

      .sub {
        display: flex;
        align-items: center;
        p {
          font-weight: bold;
        }

        .icon {
          padding: 4px;
          background: $gray100;
          border-radius: 4px;
          margin-right: 8px;

          img {
          }
        }
      }
    }
  }

  .button {
    margin: 16px 32px;
  }
}
</style>
